import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {TranslateModule} from '@ngx-translate/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MydocmaStepperComponent} from './components/stepper/mydocma-stepper.component';
import {MatIconModule, MatProgressBarModule, MatStepperModule} from '@angular/material';
import {StepTemplateDirective} from './directives/step-template.directive';
import {StepperService} from './stepper.service';
import {StepComponentDirective} from './directives/step-component.directive';
import {ExecutionStepComponent} from './execution/execution-step/execution-step.component';
import {ExecutionService} from './execution/execution.service';
import {ExecutionStepItemComponent} from './execution/execution-step-item/execution-step-item.component';
import { CustomMatIconModule } from '@mydocma/component-library/src/lib/custom-mat-icon';

@NgModule({
    declarations: [
        MydocmaStepperComponent,
        StepComponentDirective,
        StepTemplateDirective,
        ExecutionStepComponent,
        ExecutionStepItemComponent
    ],
    imports: [
        CommonModule,
        FlexLayoutModule,
        FormsModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatStepperModule,
        ReactiveFormsModule,
        TranslateModule,
        CustomMatIconModule,
        MatProgressBarModule
    ],
    providers: [
        ExecutionService,
        StepperService
    ],
    exports: [
        MydocmaStepperComponent,
        StepComponentDirective,
        StepTemplateDirective,
        ExecutionStepComponent,
    ]
})
export class MydocmaStepperModule {
}
